import React, { useRef, useEffect } from "react";

import "./header.css";

const nav__links = [
  {
    path: "#accueil",
    display: "Accueil",
  },
  {
    path: "#about ",
    display: "A propos",
  },
  {
    path: "#service ",
    display: "Services",
  },
  {
    path: "#blog ",
    display: "Blog",
  },
  {
     path: "#contact ",
     display: "Contact",
   },
];

const Header = ({ theme, toggleTheme }) => {
  const headerRef = useRef(null);

  const menuRef = useRef(null);

  const headerFunc = () => {
    if (
      document.body.scrollTop > 80 ||
      document.documentElement.scrollTop > 80
    ) {
      headerRef.current.classList.add("header__shrink");
    } else {
      headerRef.current.classList.remove("header__shrink");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", headerFunc);
    return () => window.removeEventListener("scroll", headerFunc);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();

    const targetAttr = e.target.getAttribute("href");

    const location = document.querySelector(targetAttr).offsetTop;

    window.scrollTo({
      left: 0,
      top: location - 80,
    });
  };

  const toggleMenu = () => menuRef.current.classList.toggle("menu__active");

  return (
    <header className="header" ref={headerRef}>
      <div className="container">
        <div className="nav__wrapper">
          <div className="logo">
            <a href="#accueil" className="menu__link">
              <h2>IDA VISION</h2>
            </a>
          </div>

          {/*================navigation=================*/}
          <div className="navigation" ref={menuRef} onClick={toggleMenu}>
            <ul className="menu">
              {nav__links.map((item, index) => (
                <li className="menu__item" key={index}>
                  <a
                    href={item.path}
                    onClick={handleClick}
                    className="menu__link"
                    //onClick={closeMenu}
                    
                  >
                    {item.display}
                  </a>
                </li>

               /*  <Link spy={true} to="Experience" smooth={true}>
                <li className="menu__link" onClick={handleClick}>Expérience</li>
              </Link> */
              ))}
            </ul>
          </div>
          {/*================light mode=================*/}
          <div className="light__mode">
            <span onClick={toggleTheme}>
              {theme === "light-theme" ? (
                <span>
                  <i class="ri-moon-line"></i>Mode Sombre
                </span>
              ) : (
                <span>
                  <i class="ri-sun-line"></i>Mode Clair
                </span>
              )}
            </span>
          </div>

          <span className="mobile__menu" onClick={toggleMenu}>
            <i class="ri-menu-line"></i>
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
